// frontend/src/components/auth/RequireAdmin.js
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function RequireAdmin({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <p>로딩 중...</p>;
    if (!user || user.role !== 'admin') {
        return <Navigate to="/unauthorized" replace />;
    }
    return children;
}
